import React, { Component } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import { Button, Row, Col, Form, Container } from 'react-bootstrap';

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    titulo: {
        fontSize: '25px'
    },
    subtitulo: {
        marginTop: '25px',
        marginBottom: '25px',
        fontSize: '20px'
    },
    buttonsActionWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
});

class EncerrarSessao extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
        }

        this.handleEncerrarSessao = this.handleEncerrarSessao.bind(this);
    }

    render() {
        const { classes, handleModalClose } = this.props;
        return (
            <Paper className={classes.root}>
                <Container style={{minWidth: 500}}>
                    <Row>
                        <Col className={classes.headerWrapper}>
                            <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Typography className={classes.titulo}>Ao clicar nesse botão a sessão será encerada <br/> e todos os participantes serão desconectados.</Typography>
                            <Typography className={classes.subtitulo}>Deseja continuar?</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={classes.buttonsActionWrapper}>
                            <Button variant="red" type="submit" onClick={this.handleEncerrarSessao}>Encerrar Sessão</Button>
                            <Button variant="primary-get" type="submit" onClick={() => handleModalClose()}>Cancelar</Button>
                        </Col>
                    </Row>
                </Container>
            </Paper>
        )
    }

    handleEncerrarSessao() {
        const { handleModalSaveChange } = this.props;
        handleModalSaveChange();
    }

}

export default withStyles(classes)(EncerrarSessao);